export const initialState = {
  apiStatus: { loading: false, message: null, next: false, data: null, isError: false },
};
